<template>
	<div>
		<v-row>
			<v-breadcrumbs :items="breadcrumbs" divider="/" class="mb-4"></v-breadcrumbs>
		</v-row>
		<v-stepper v-model="step" alt-labels>
			<v-stepper-header>
				<v-stepper-step :complete="step > 1" step="1">{{ $t('Тип заявки') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 1" step="2">{{ $t('Профдиагностика') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 2" step="3">{{ $t('Данные') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 3" step="4">{{ $t('Образование') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 4" step="5">{{ $t('Квота') }}</v-stepper-step>
				<v-divider></v-divider>
				<v-stepper-step :complete="step > 5" step="6">{{ $t('Специальность') }}</v-stepper-step>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<div v-if="metadataLoading" class="text-center py-8">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</div>
					<template v-else-if="usesMetadataApi">
						<v-card
							v-for="(item, index) in applicationTypeCards"
							:key="'step1-' + index"
							outlined
							class="mb-4"
						>
							<v-card-text class="text-h6">
								{{ item.title }}<br>
								<div class="blue--text text-darken-3 font-weight-bold">{{ item.subtitle }}</div>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn depressed @click.stop="selectApplicationType(item)">{{ $t('Продолжить') }}</v-btn>
							</v-card-actions>
						</v-card>
					</template>
					<template v-else>
					<!-- <v-alert
						prominent
						dense
						border="left"
						colored-border
						type="info"
						color="orange darken-1">
						<div class="text-h6 mb-3">Внимание!!!</div>
						
						<p>В целях обеспечения безопасности граждан и учитывая возникшие трудности при получении медицинских справок о состоянии здоровья, Министром образования и науки подписан приказ, временно разрешающий прием документов в организации образования без предъявления медицинских справок.</p>

						<p>При подаче онлайн заявления на портале «электронного правительства» - закрепление медицинских справок не обязательное поле.</p>
					</v-alert> -->
					

					<v-card outlined class="mb-4">
						<v-card-text class="text-h6">
							{{ $t('Подготовка специалистов среднего звена и прикладного бакалавра') }}<br>
							<div class="blue--text text-darken-3 font-weight-bold">{{ $t('Бесплатное, за счет средств государственного образовательного заказа') }}</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn depressed  @click.stop="requestData.training_type_id = 1; requestData.payment_type_id = 2; step++;">{{ $t('Продолжить') }}</v-btn>
						</v-card-actions>
					</v-card>
					<v-card outlined class="mb-4">
						<v-card-text class="text-h6">
							{{ $t('Подготовка квалифицированных рабочих кадров') }}<br>
							<div class="blue--text text-darken-3 font-weight-bold">{{ $t('Бесплатное, за счет средств государственного образовательного заказа') }}</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn depressed  @click.stop="requestData.training_type_id = 2; requestData.payment_type_id = 2; step++;">{{ $t('Продолжить') }}</v-btn>
						</v-card-actions>
					</v-card>
					<v-card outlined class="mb-4">
						<v-card-text class="text-h6">
							{{ $t('Подготовка специалистов среднего звена и прикладного бакалавра') }}<br>
							<div class="blue--text text-darken-3 font-weight-bold">{{ $t('Платное, за счет собственных средств') }}</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn depressed  @click.stop="requestData.training_type_id = 1; requestData.payment_type_id = 1; step++;">{{ $t('Продолжить') }}</v-btn>
						</v-card-actions>
					</v-card>
					<!-- <v-card outlined class="mb-4">
						<v-card-title>Подготовка квалифицированных рабочих кадров (Платное, за счет собственных средств)</v-card-title>
						<v-card-text>
							<p><strong>Как получить услугу в государственном органе&nbsp;</strong>(необходимые документы):&nbsp;&nbsp;</p>

							<ol>
								<li>заявление о приеме документов;</li>
								<li>подлинник документа об образовании;</li>
								<li>фотографии размером 3х4 см в количестве 4-х штук;</li>
								<li>медицинская справка формы № 075-У, для инвалидов І и II группы и инвалидов с детства заключение медико-социальной экспертизы по форме 031-У;</li>
								<li>документ, удостоверяющий личность (для идентификации личности).</li>
							</ol>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn depressed  @click.stop="requestData.training_type_id = 2; requestData.payment_type_id = 1; step++;">Подать заявку</v-btn>
						</v-card-actions>
					</v-card> -->
					</template>
				</v-stepper-content>

				<v-stepper-content step="2">
					{{ $t('Пройдите профдиагностику на сайте') }} <a href="https://edunavigator.kz/" target="_blank" class="">BTS·Education</a>
					
					<v-checkbox v-model="btsCheckbox" :label="$t('Я получил(а) и ознакомился(ась) с результатами профдиагностики')"></v-checkbox>

					<div class="text-right">
						<v-btn v-if="!requestData.is_undeveloped_place" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step3" :disabled="!btsCheckbox" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="3">
					<v-form class="form" ref="formStep3">
						<v-select
							v-if="!showDeclarantTypeAlert"
							v-model="requestData.declarant_type_id"
							:items="firstDeclarantType"
							item-text="name"
							item-value="id"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип заявителя')">
						</v-select>
						<v-alert
							v-else
							dense
							outlined
							type="info"
							class="mb-4"
						>
							<strong>{{ $t('Тип заявителя') }}:</strong> {{ declarantTypeLabel }}
						</v-alert>
						<!--<div>
							<p v-if="!requestSent">
								{{ $t('Чтобы продолжить, нажмите на кнопку ниже. Мы отправим вам сообщение для подтверждения вашей личности.') }}
							</p>
								<v-btn v-if="!requestSent" @click="sendRequest" color="primary">
								{{ $t('Отправить запрос ') }}
								</v-btn>
								<v-btn v-if="requestSent && !dataReceived" @click="checkStatus" color="primary">
								{{ $t('Проверка запроса') }}
								</v-btn>
								<p v-if="notification">{{ notification }}</p>
								<v-select
								v-if="dataReceived"
								v-model="selectedChildIIN"
								:items="data"
								item-text="name"
								item-value="iin"
								:rules="[v => !!v || $t('Обязательное поле')]"
								:label="$t('Выбери ребенка')"
								@change="fetchChildData"
								></v-select>
							</div>-->
						
						<template v-if="requestData.declarant_type_id">
							
							<v-card outlined class="mb-4">
								<v-card-title>{{ $t('Данные абитуриента') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="selectedChild.surname"
												:label="$t('Фамилия')"
												type="text"
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="selectedChild.name"
												:label="$t('Имя')"
												type="text"
												:rules="[v => !!v || $t('Обязательное поле')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-text-field
												v-model="selectedChild.patronymic"
												:label="$t('Отчество')"
												type="text"
											></v-text-field>
										</v-col>
										<v-col sm="3" cols="12">
											<v-menu
												v-model="datePickerMenu"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="auto">
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="selectedChild.birthday"
														:label="$t('Дата рождения')"
														readonly
														prepend-icon="mdi-calendar"
														:rules="birthdayDateRules"
														required
														v-bind="attrs"
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
													v-model="selectedChild.birthday"
													min="1901-01-01"
													:max="maxBirthdayDate"
													@input="onChildBirthdayChange"
												></v-date-picker>
											</v-menu>
										</v-col>
									</v-row>
									<v-row>
										<v-col sm="4" cols="12">
											<v-select
												v-model="requestData.citizen_status_id"
												:items="citizenStatusList"
												item-text="name"
												item-value="id"
												:rules="[v => !!v || $t('Обязательное поле')]"
												:label="$t('Статус гражданина')">
											</v-select>
										</v-col>
										<v-col sm="4" cols="12">
											<v-select
												v-model="requestData.nationality_id"
												:items="nationalityList"
												item-text="name"
												item-value="id"
												:rules="[v => !!v || $t('Обязательное поле')]"
												:label="$t('Национальность')">
											</v-select>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="selectedChild.iin "
												:label="$t('ИИН')"
												type="number"
												:rules="[v => !v || v.match(/\d/g).length === 12 || $t('Неправильный формат ИИН')]"
												@wheel="$event.target.blur()"
											></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

							<v-card outlined class="mb-4">
								<v-card-title>{{ $t('Контактные данные') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.email"
												:label="$t('Электронная почта')"
												type="text"
												:rules="[v => !!v || $t('Обязательное поле'), v => /.+@.+\..+/.test(v) || $t('Введите корректный E-mail')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.phone_number"
												:label="$t('Номер телефона абитуриента')"
												prefix="+"
												type="number"
												@wheel="$event.target.blur()"
												:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
												required
											></v-text-field>
										</v-col>
										<v-col sm="4" cols="12">
											<v-text-field
												v-model="requestData.parent_phone_number"
												:label="$t('Номер телефона родителя')"
												type="number"
												prefix="+"
												@wheel="$event.target.blur()"
												:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
												required
											></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Медицинские данные') }}</v-card-title>
								<v-card-text>
									<v-row>
										<v-col sm="12" cols="12">
											<v-file-input
													:label="$t('Медицинская справка 075/У (086)')"
													accept="image/*,application/pdf"
													:rules="[requiredFileRule, fileSizeRule]"
													@change="form086ToBase64"
													required >
											</v-file-input>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

								<v-row>
									<v-col>
										<v-checkbox v-model="requestData.instructionCheck" :label="$t('С Единой инструкцией по проведению Конкурса ознакомлен(-а)')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
									<v-col>
										<v-checkbox v-model="requestData.personalDataCheck" :label="$t('Даю согласие на сбор, обработку персональных данных')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
								</v-row>
						</template>
					</v-form>
					
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step4" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="4">
					<v-form class="form" ref="formStep4">
						<v-select
							v-model="requestData.education_type_id"
							:items="educationTypeList"
							item-text="name"
							item-value="id"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип образования')">
						</v-select>

						<template v-if="requestData.education_type_id">
							<v-card outlined class="mb-4" v-if="requestData.education_type_id == 1 || requestData.education_type_id == 2">
								<v-card-title>{{ $t('Данные о школе') }}</v-card-title>
								<v-card-text>

									<v-autocomplete
										v-model="requestData.school_country_id"
										:items="countryList"
										item-text="name"
										item-value="id"
										:label="$t('Страна')"
										clearable
										:rules="[v => !!v || $t('Обязательное поле')]">
									</v-autocomplete>
									<template v-if="requestData.school_country_id == 398 || requestData.school_country_id == 192">
										<v-select
											v-model="requestData.school_region_ab"
											:items="regionList"
											item-text="name"
											:item-value="schoolRegionItemValue"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Регион')"
											@change="onSchoolRegionChange">
										</v-select>
										<v-autocomplete
											:key="'school-' + requestData.school_region_ab"
											v-model="requestData.school_id"
											:items="schoolList"
											item-text="name"
											item-value="id"
											:label="$t('Школа')"
											clearable
											:rules="[schoolIdRule]">
										</v-autocomplete>
									</template>
									

								</v-card-text>
							</v-card>
							<v-text-field
								v-model="requestData.graduation_year"
								:label="$t('Год окончания')"
								type="text"
								inputmode="numeric"
								maxlength="4"
								@input="onGraduationYearInput"
								:rules="graduationYearRules"
								required
							></v-text-field>
							
							<v-select
								v-model="requestData.education_document_type_id"
								:items="educationDocumentList"
								item-text="name"
								item-value="id"
								:rules="[v => !!v || $t('Обязательное поле')]"
								:label="$t('Тип документа')">
							</v-select>
							
							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Документ об образовании') }}</v-card-title>
								<v-card-text>
									<v-file-input
										:label="$t('Документ об образовании')"
										accept="image/*,application/pdf"
										:rules="[requiredFileRule, fileSizeRule]"
										@change="educationDocumentToBase64"
										required >
									</v-file-input>
								</v-card-text>
							</v-card>
						</template>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step5" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="5">
					<v-form class="form" ref="formStep5">
						<v-select
							v-model="requestData.quota_list[0].id"
							:items="quotaCategoryList"
							@change="quotaCategoryChanged"
							item-text="name"
							item-value="id"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Тип льготы')">
						</v-select>
						<template v-if="needsQuotaFile">
							<v-card outlined class="mb-4">
								<v-card-title>{{ fileSectionTitle('Документ подтверждающий льготу') }}</v-card-title>
								<v-card-text>
									<v-file-input
										:label="$t('Документ подтверждающий льготу')"
										accept="image/*,application/pdf"
										:rules="[requiredFileRule, fileSizeRule]"
										@change="quotaDocumentToBase64"
										required >
									</v-file-input>
								</v-card-text>
							</v-card>
						</template>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="step6" :loading="isLoading">{{ $t('Далее') }}</v-btn>
					</div>
				</v-stepper-content>

				<v-stepper-content step="6">
					<v-form class="form" ref="formStep6">
						<v-select
							v-model="requestData.education_form_id"
							:items="educationFormList"
							@change="clearQualificationList"
							item-text="name"
							item-value="id"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Форма обучения')">
						</v-select>
						<v-select
							v-model="requestData.region_ab"
							:items="regionIsEdusList"
							@change="clearQualificationList"
							item-text="name"
							:item-value="schoolRegionItemValue"
							:readonly="requestData.is_undeveloped_place"
							:rules="[v => !!v || $t('Обязательное поле')]"
							:label="$t('Регион')">
						</v-select>
						<div
							v-if="requestData.region_ab && requestData.education_form_id"
							:key="'qualifications-' + requestData.region_ab + '-' + requestData.education_form_id"
						>
							<v-card outlined class="mb-4" v-for="(item, index) in requestData.choosed_qualification" :key="'qualification-' + index">
								<v-card-text>
									<v-btn fab small depressed text v-if="index != 0" @click.stop="removeQualificationBlock(index)" style="position: absolute; top: 0; right: 0;">
										<v-icon>mdi-close</v-icon>
									</v-btn>
									<v-autocomplete
											v-model="qualificationSelected[index]"
											:items="qualificationList"
											item-value="qualification_code"
											:label="$t('Специальность №')+(index+1)"
											@change="qualificationChanged($event, index)"
											:clearable="!requestData.is_undeveloped_place"
											:filter="customQualificationFilter"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !v || Object.keys(v).length != 0 || $t('Обязательное поле')]"
											return-object>
											<template v-slot:item="{ item }">
												<div class="py-3">
													<template v-if="usesMetadataApi">
														{{ item.display_label }}
													</template>
													<template v-else>
														{{item.qualification_code}} ({{item.specialty_code}}) – {{item.name}} ({{item.specialty_name}})
													</template>
												</div>
											</template>
											<template v-slot:selection="{ item }">
											<span style="text-overflow: ellipsis; overflow: hidden; width: 90%; white-space: nowrap; position: absolute;">
												<template v-if="usesMetadataApi">
													{{ item.display_label }}
												</template>
												<template v-else>
													{{item.qualification_code}} ({{item.specialty_code}}) – {{item.name}} ({{item.specialty_name}})
												</template>
											</span>
											</template>
									</v-autocomplete>

									<template v-if="usesMetadataApi">
										<v-select
											v-if="qualificationSelected[index] && qualificationSelected[index].colleges"
											v-model="item.college_id"
											:items="collegeList[index]"
											@change="newApiCollegeChanged(index)"
											item-text="name"
											item-value="college_id"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Организация образования')">
										</v-select>
										<v-select
											v-if="item.college_id"
											v-model="item.lang"
											:items="collegeLangList[index]"
											item-text="name"
											item-value="lang_short"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Язык обучения')">
										</v-select>
									</template>
									<template v-else>
										<v-select
											v-model="item.bin"
											:items="collegeList[index]"
											@change="collegeChanged(index)"
											item-text="name"
											item-value="college_bin"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Организация образования')">
										</v-select>
										<v-select
											v-model="item.lang"
											:items="collegeLangList[index]"
											@change="languageChanged(index)"
											item-text="name"
											item-value="lang_short"
											:readonly="requestData.is_undeveloped_place"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Язык обучения')">
										</v-select>

										<v-checkbox
											v-if="collegeTargetGrantList[index]"
											v-model="item.target_grant"
											:label="$t('Хочу участвовать в целевом гранте')"
										></v-checkbox>
									</template>
								</v-card-text>
							</v-card>
							<v-btn color="primary" @click.stop="addQualificationBlock" v-if="requestData.payment_type_id == 2 && requestData.training_type_id == 1 && maxChoosedQualificationCoun > requestData.choosed_qualification.length && !requestData.is_undeveloped_place">
								{{ $t('Добавить еще одну специальность') }}
							</v-btn>
						</div>

						<v-divider class="my-4"></v-divider>
						<sign-ecp
							@update-ecp-file-data="requestData.p12 = $event"
							@update-ecp-password="requestData.password = $event"
						/>
					</v-form>
					<div class="text-right">
						<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0" :loading="isLoading">{{ $t('Назад') }}</v-btn>
						<v-btn color="primary" @click.stop="submitRequest" :loading="isLoading">{{ $t('Отправить') }}</v-btn>
					</div>
				</v-stepper-content>

			
			</v-stepper-items>
		</v-stepper>


					

	</div>
</template>

<script>
	import {
		mapMetadataToSelectItems,
		getParentDeclarantTypeLabel,
		resolveParentDeclarantTypeId,
		buildStep1ApplicationTypes,
		buildDefaultEducationRelations,
		mapRelationsDocuments,
		normalizeRegions,
		mapQualificationApiResponse,
		buildQualificationFormBody,
		mapCollegeLangOptions,
	} from '@/utils/metadata';
	import { formatSchoolList } from '@/utils/format';
	import { buildAddOrderFormData, createBirthdayDateRules, formatMaxBirthdayDate } from '@/utils/orderForm';
	import { buildFileSectionTitle, createFileSizeRule } from '@/utils/fileUpload';

	export default {
		computed: {
			usesMetadataApi() {
				return this.$store.getters.usesAbiturientNewApi && this.metadataLoaded;
			},
			applicationTypeCards() {
				return buildStep1ApplicationTypes(this.metadata);
			},
			showDeclarantTypeAlert() {
				return this.$store.getters.usesAbiturientNewApi;
			},
			declarantTypeLabel() {
				return getParentDeclarantTypeLabel(this.metadata, this.requestData.declarant_type_id)
					|| this.$t('Родитель/законный представитель');
			},
			firstDeclarantType() {
				return this.declarantTypeList.filter((item) => item.name === 'Родитель');
			},
			schoolRegionItemValue() {
				return this.usesMetadataApi ? 'id' : 'ab';
			},
			graduationYearRules() {
				const currentYear = new Date().getFullYear();
				return [
					(v) => !!v || this.$t('Обязательное поле'),
					(v) => !v || /^\d{4}$/.test(String(v)) || this.$t('Неправильный формат'),
					(v) => !v || Number(v) >= 1901 || this.$t('Год не может быть меньше 1901'),
					(v) => !v || Number(v) <= currentYear || this.$t('Год не может быть больше текущего'),
				];
			},
			birthdayDateRules() {
				return createBirthdayDateRules((key) => this.$t(key));
			},
			maxBirthdayDate() {
				return formatMaxBirthdayDate();
			},
			needsQuotaFile() {
				const quotaId = this.requestData.quota_list[0] && this.requestData.quota_list[0].id;
				return quotaId && quotaId !== 0 && quotaId !== '0' && quotaId !== 3 && quotaId !== '3';
			},
			breadcrumbs() {
				return [
					{
						text: this.$t('Главная'),
						disabled: false,
						exact: true,
						to: '/abiturient',
					},
					{
						text: this.$t('Мои заявки'),
						disabled: false,
						exact: true,
						to: '/abiturient/my-requests',
					},
					{
						text: this.$t('Новая заявка'),
						disabled: true,
						exact: true,
						to: '',
					}
				];
			},
			selectedChild() {
				return this.$store.state.selectedChild;
			},
		},
		async mounted() {
			if (!this.selectedChild) {
				this.$router.replace({ name: 'abiturient-children' });
				return;
			}
			if (this.$store.getters.usesAbiturientNewApi) {
				await this.loadMetadata();
			}
			if (+this.$route.query.is_undeveloped_place === 1) {
				this.requestData.is_undeveloped_place = true;
				this.requestData.training_type_id = this.$route.query.training_type_id;
				this.requestData.payment_type_id = this.$route.query.payment_type_id;
				this.requestData.education_type_id = this.$route.query.education_type_id;
				this.requestData.education_form_id = this.$route.query.education_form_id;
				this.requestData.region_ab = this.$route.query.region_ab;
				this.clearQualificationList();
				this.qualificationSelected[0] = this.$route.query.qualification_code;
				this.requestData.choosed_qualification[0] = {
					code: this.$route.query.qualification_code,
					specialty_code: this.$route.query.specialty_code,
					bin: this.$route.query.college_bin,
					lang: this.$route.query.lang_short,
				};
				this.getCollege(0);
				this.getCollegeLang(0);
				this.step++;
			}
			if (!this.usesMetadataApi) {
				this.getDeclarantType();
			}
		},
		data () {
			return {
				metadata: null,
				metadataLoaded: false,
				metadataLoading: false,
				isLoading: false,
				step: 1,
				btsCheckbox: false,
				declarantTypeList: [],
				citizenStatusList: [],
				educationTypeList: [],
				nationalityList: [],
				datePickerMenu: false,
				countryList: [],
				regionList: [],
				regionIsEdusList: [],
				schoolList: [],
				educationDocumentList: [],
				educationRelations: [],
				relationsLoaded: false,
				quotaCategoryList: [],
				educationFormList: [],
				qualificationList: [],
				qualificationSelected: [],
				collegeList: [],
				collegeLangList: [],
				collegeTargetGrantList: [],
				choosedQualificationItem: {
					specialty_code: null,
					code: null,
					bin: null,
					lang: null,
					college_id: null,
				},
				maxChoosedQualificationCoun: 4,
				form086File: null,
				educationDocumentFile: null,
				quotaDocumentFile: null,
				requestData: {
					training_type_id: null,
					payment_type_id: null,
					declarant_type_id: null,
					citizen_status_id: null,
					surname: null,
					name: null,
					lastname: null,
					iin: null,
					birthday: null,
					email: null,
					phone_number: null,
					parent_phone_number: null,
					nationality_id: null,
					graduation_year: null,
					education_type_id: null,
					school_country_id: 398,
					school_region_ab: null,
					school_id: null,
					education_document_type_id: null,
					education_document: null,
					form_086: null,
					form_086_document: null,
					instructionCheck: false,
					personalDataCheck: false,
					is_have_quota: null,
					quota_list: [
						{
							id: null,
							document: null,
						},
					],
					region_ab: null,
					education_form_id: null,
					choosed_qualification: [],
					p12: null,
					password: null,
					is_undeveloped_place: false,
				},
			};
		},
		methods: {
			requiredFileRule(value) {
				return !!value || this.$t('Обязательное поле');
			},
			fileSectionTitle(titleKey) {
				return buildFileSectionTitle((key) => this.$t(key), titleKey);
			},
			fileSizeRule(file) {
				return createFileSizeRule((key) => this.$t(key))(file);
			},
			onGraduationYearInput(value) {
				const digits = String(value || '').replace(/\D/g, '').slice(0, 4);
				this.requestData.graduation_year = digits === '' ? null : digits;
			},
			schoolIdRule(v) {
				if (v === 0 || v === '0' || v) {
					return true;
				}
				return this.$t('Обязательное поле');
			},
			selectApplicationType(item) {
				this.requestData.training_type_id = item.training_type_id;
				this.requestData.payment_type_id = item.payment_type_id;
				this.step++;
			},
			async loadMetadata(force = false) {
				if (this.metadataLoaded && !force) {
					return;
				}
				this.metadataLoading = true;
				try {
					const response = await this.$http.get('/metadata');
					this.metadata = response.data.data || response.data;
					this.metadataLoaded = true;
					this.applyMetadataLists();
				} catch (error) {
					console.error('Ошибка загрузки metadata:', error);
				} finally {
					this.metadataLoading = false;
				}
			},
			async reloadLocalizedListsOnLanguageChange() {
				this.metadataLoaded = false;
				this.metadata = null;
				await this.loadMetadata(true);
				if (this.countryList.length) {
					this.countryList = [];
					await this.getCountry(true);
				}
				if (this.relationsLoaded) {
					this.relationsLoaded = false;
					this.educationRelations = [];
					await this.loadRelations(true);
					this.applyEducationDocumentsFromRelations();
				}
				if (this.nationalityList.length) {
					this.nationalityList = [];
					await this.getNationality(true);
				}
				if (this.regionList.length) {
					this.regionList = [];
					await this.getRegion(true);
				}
				if (this.requestData.school_region_ab) {
					await this.getSchool();
				}
				if (this.regionIsEdusList.length) {
					this.regionIsEdusList = [];
					await this.getRegionIsEdus(true);
				}
				if (this.qualificationList.length) {
					await this.getQualification();
				}
			},
			applyMetadataLists() {
				if (!this.metadata) {
					return;
				}
				this.citizenStatusList = mapMetadataToSelectItems(this.metadata.citizen_status);
				this.declarantTypeList = mapMetadataToSelectItems(this.metadata.declarant_type);
				this.educationTypeList = mapMetadataToSelectItems(this.metadata.education_type);
				this.educationFormList = mapMetadataToSelectItems(this.metadata.education_form);
			},
			async loadRelations(force = false) {
				if (this.relationsLoaded && !force) {
					return;
				}
				try {
					const response = await this.$http.get('/relations', { silent: true });
					const data = response.data.data || response.data;
					this.educationRelations = Array.isArray(data) ? data : [];
				} catch (error) {
					console.error('Ошибка загрузки relations:', error);
					this.educationRelations = buildDefaultEducationRelations(this.metadata);
				}
				this.relationsLoaded = true;
			},
			applyEducationDocumentsFromRelations() {
				this.educationDocumentList = mapRelationsDocuments(
					this.educationRelations,
					this.requestData.education_type_id
				);
				if (this.requestData.education_document_type_id) {
					const isValid = this.educationDocumentList.some(
						(item) => item.id === this.requestData.education_document_type_id
					);
					if (!isValid) {
						this.requestData.education_document_type_id = null;
					}
				}
			},
			syncChildToRequestData() {
				const child = this.selectedChild;
				if (!child) {
					return;
				}
				this.requestData.surname = child.surname || '';
				this.requestData.name = child.name || '';
				this.requestData.lastname = child.patronymic || '';
				this.requestData.iin = String(child.iin || '').trim();
				this.requestData.birthday = child.birthday || '';
			},
			applyParentContactDefaults() {
				const info = this.$store.getters.getAbiturientInfo || {};
				if (!this.requestData.email && info.email) {
					this.requestData.email = info.email;
				}
				if (!this.requestData.parent_phone_number && (info.phone || info.phone_number)) {
					this.requestData.parent_phone_number = info.phone || info.phone_number;
				}
			},
			prepareStep3() {
				if (this.showDeclarantTypeAlert) {
					this.requestData.declarant_type_id = resolveParentDeclarantTypeId(this.metadata);
					this.syncChildToRequestData();
					this.applyParentContactDefaults();
				}
			},
			onChildBirthdayChange() {
				this.datePickerMenu = false;
				this.syncChildToRequestData();
			},
			async step3() {
				if (this.showDeclarantTypeAlert) {
					this.prepareStep3();
					await this.getNationality();
					this.step++;
					return;
				}
				await this.getDeclarantType();
				await this.getCitizenStatus();
				await this.getNationality();
				this.syncChildToRequestData();
				this.step++;
			},
			async step4() {
				if (this.$refs.formStep3.validate()) {
					this.syncChildToRequestData();
					if (this.usesMetadataApi) {
						await this.loadRelations();
						this.applyEducationDocumentsFromRelations();
					} else {
						await this.getEducationType();
					}
					this.step++;
				}
			},
			async step5() {
				if (this.$refs.formStep4.validate()) {
					await this.getQuotaCategory();
					this.step++;
				}
			},
			async step6() {
				if (this.$refs.formStep5.validate()) {
					this.getEducationForm();
					this.getRegionIsEdus();
					this.step++;
				}
			},

			async getDeclarantType() {
				if (!this.declarantTypeList.length) {
					this.isLoading = true;
					await this.$http.get('/declarantType').then((response) => {
						this.declarantTypeList = response.data.data;
						const parent = this.declarantTypeList.find((item) => item.name === 'Родитель');
						if (parent) {
							this.requestData.declarant_type_id = parent.id;
						}
					});
					this.isLoading = false;
				}
			},
			async getCitizenStatus() {
				if (!this.citizenStatusList.length) {
					this.isLoading = true;
					await this.$http.get('/citizenStatus').then((response) => {
						this.citizenStatusList = response.data.data;
					});
					this.isLoading = false;
				}
			},
			async getNationality(force = false) {
				if (this.nationalityList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/nationality');
					const data = response.data.data || response.data;
					this.nationalityList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getEducationType() {
				if (!this.educationTypeList.length) {
					this.isLoading = true;
					await this.$http.get('/educationType').then((response) => {
						this.educationTypeList = response.data.data;
					});
					this.isLoading = false;
				}
			},
			async getCountry(force = false) {
				if (this.countryList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/country');
					const data = response.data.data || response.data;
					this.countryList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getRegion(force = false) {
				if (this.regionList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const response = await this.$http.get('/regions');
						const data = response.data.data || response.data;
						this.regionList = Array.isArray(data) ? data : [];
					} else {
						const response = await this.$http.post('/region', {
							country_id: 398,
						});
						this.regionList = response.data.data;
					}
				} finally {
					this.isLoading = false;
				}
			},
			async getRegionIsEdus(force = false) {
				if (this.regionIsEdusList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const response = await this.$http.get('/regions');
						const data = response.data.data || response.data;
						this.regionIsEdusList = normalizeRegions(data);
					} else {
						const response = await this.$http.post('/region', {
							country_id: 398,
							is_edus: true,
						});
						this.regionIsEdusList = normalizeRegions(response.data.data);
					}
				} finally {
					this.isLoading = false;
				}
			},
			onSchoolRegionChange() {
				this.requestData.school_id = null;
				this.schoolList = [];
				this.getSchool();
			},
			async getSchool() {
				const regionId = this.requestData.school_region_ab;
				if (!regionId) {
					this.schoolList = [];
					return;
				}
				this.isLoading = true;
				try {
					let schools = [];
					if (this.usesMetadataApi) {
						const body = new URLSearchParams();
						body.append('id', regionId);
						const response = await this.$http.post('/schools', body);
						const data = response.data.data || response.data;
						schools = formatSchoolList(data);
					} else {
						const response = await this.$http.post('/school', {
							region_ab: regionId,
						});
						schools = formatSchoolList(response.data.data);
					}
					if (this.requestData.school_region_ab !== regionId) {
						return;
					}
					this.schoolList = schools;
					this.schoolList.push({
						id: '0',
						name: this.$t('Другое'),
					});
					if (this.schoolList.length === 1) {
						this.requestData.school_id = '0';
					}
				} catch (error) {
					if (this.requestData.school_region_ab === regionId) {
						this.schoolList = [];
					}
					console.error('Ошибка загрузки школ:', error);
				} finally {
					if (this.requestData.school_region_ab === regionId) {
						this.isLoading = false;
					}
				}
			},
			async getEducationDocument() {
				if (this.usesMetadataApi) {
					await this.loadRelations();
					this.applyEducationDocumentsFromRelations();
					return;
				}
				this.isLoading = true;
				await this.$http.post('/educationDocument', {
					education_type_id: this.requestData.education_type_id,
				}).then((response) => {
					this.educationDocumentList = response.data.data;
				});
				this.isLoading = false;
			},
			async getQuotaCategory() {
				if (!this.quotaCategoryList.length) {
					this.isLoading = true;
					const endpoint = this.usesMetadataApi ? '/quota' : '/quotaCategory';
					await this.$http.get(endpoint).then((response) => {
						this.quotaCategoryList = response.data.data;
						this.quotaCategoryList.unshift({
							id: '0',
							name: this.$t('Без льготы'),
						});
					});
					this.isLoading = false;
				}
			},
			quotaCategoryChanged(v) {
				this.requestData.is_have_quota = v != 0;
				if (v == 0) {
					this.requestData.quota_list[0].document = null;
					this.quotaDocumentFile = null;
				}
			},
			async getEducationForm() {
				if (!this.educationFormList.length) {
					this.isLoading = true;
					await this.$http.get('/educationForm').then((response) => {
						this.educationFormList = response.data.data;
					});
					this.isLoading = false;
				}
			},

			clearQualificationList() {
				this.requestData.choosed_qualification = [];
				this.qualificationSelected = [];
				this.qualificationList = [];
				this.collegeList = [];
				this.collegeLangList = [];
				this.collegeTargetGrantList = [];
				this.addQualificationBlock();
				if (this.requestData.education_form_id && this.requestData.region_ab) {
					this.getQualification();
				}
			},
			addQualificationBlock() {
				this.qualificationSelected.push({});
				this.requestData.choosed_qualification.push(Object.assign({}, this.choosedQualificationItem));
			},
			customQualificationFilter(item, queryText) {
				const searchText = queryText.toLowerCase();
				if (this.usesMetadataApi) {
					const displayLabel = (item.display_label || '').toLowerCase();
					const name = (item.name || '').toLowerCase();
					const qualificationCode = (item.qualification_code || '').toLowerCase();
					const specialtyCode = (item.specialty_code || '').toLowerCase();
					return displayLabel.includes(searchText)
						|| name.includes(searchText)
						|| qualificationCode.includes(searchText)
						|| specialtyCode.includes(searchText);
				}
				const qualificationCode = (item.qualification_code || '').toLowerCase();
				const specialtyCode = (item.specialty_code || '').toLowerCase();
				const specialtyName = (item.specialty_name || '').toLowerCase();
				const name = (item.name || '').toLowerCase();
				return qualificationCode.includes(searchText)
					|| specialtyCode.includes(searchText)
					|| specialtyName.includes(searchText)
					|| name.includes(searchText);
			},
			removeQualificationBlock(index) {
				this.requestData.choosed_qualification.splice(index, 1);
				this.qualificationSelected.splice(index, 1);
				this.collegeList.splice(index, 1);
				this.collegeLangList.splice(index, 1);
				this.collegeTargetGrantList.splice(index, 1);
			},
			async getQualification() {
				const regionAb = this.requestData.region_ab;
				const educationFormId = this.requestData.education_form_id;
				if (!regionAb || !educationFormId) {
					this.qualificationList = [];
					return;
				}
				this.isLoading = true;
				try {
					let qualifications = [];
					if (this.usesMetadataApi) {
						const body = buildQualificationFormBody(this.requestData);
						const response = await this.$http.post('/qualification', body, {
							headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
						});
						const data = response.data.data || response.data;
						qualifications = mapQualificationApiResponse(data);
					} else {
						const response = await this.$http.post('/qualification', {
							region_ab: regionAb,
							training_type_id: this.requestData.training_type_id,
							education_form_id: educationFormId,
							education_type_id: this.requestData.education_type_id,
							payment_type_id: this.requestData.payment_type_id,
						});
						qualifications = response.data.data;
					}
					if (this.requestData.region_ab !== regionAb
						|| this.requestData.education_form_id !== educationFormId) {
						return;
					}
					this.qualificationList = qualifications;
				} catch (error) {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.qualificationList = [];
					}
					console.error('Ошибка загрузки специальностей:', error);
				} finally {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.isLoading = false;
					}
				}
			},
			qualificationChanged(item, index) {
				this.requestData.choosed_qualification[index].bin = null;
				this.requestData.choosed_qualification[index].college_id = null;
				this.requestData.choosed_qualification[index].lang = null;
				this.collegeList[index] = [];
				this.collegeLangList[index] = [];
				if (!item) {
					return;
				}
				this.requestData.choosed_qualification[index].specialty_code = item.specialty_code || '';
				this.requestData.choosed_qualification[index].code = item.qualification_code;
				if (this.usesMetadataApi) {
					this.collegeList[index] = item.colleges || [];
					if (item.colleges && item.colleges.length === 1) {
						this.requestData.choosed_qualification[index].college_id = item.colleges[0].college_id;
						this.newApiCollegeChanged(index);
					}
					return;
				}
				this.getCollege(index);
			},
			newApiCollegeChanged(index) {
				const selected = this.qualificationSelected[index];
				const collegeId = this.requestData.choosed_qualification[index].college_id;
				this.requestData.choosed_qualification[index].lang = null;
				this.requestData.choosed_qualification[index].bin = null;
				if (!selected || !collegeId) {
					this.collegeLangList[index] = [];
					return;
				}
				const college = (selected.colleges || []).find((c) => c.college_id === collegeId);
				if (!college) {
					this.collegeLangList[index] = [];
					return;
				}
				this.requestData.choosed_qualification[index].bin = college.college_id;
				this.collegeLangList[index] = mapCollegeLangOptions(college.lang, this.metadata);
				if (college.lang && college.lang.length === 1) {
					this.requestData.choosed_qualification[index].lang = college.lang[0];
				}
			},
			async getCollege(index) {
				this.isLoading = true;
				await this.$http.post('/college', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id,
				}).then((response) => {
					this.collegeList[index] = response.data.data;
				});
				this.isLoading = false;
			},
			collegeChanged(index) {
				this.requestData.choosed_qualification[index].lang = null;
				this.getCollegeLang(index);
			},
			async getCollegeLang(index) {
				this.isLoading = true;
				await this.$http.post('/lang', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"college_bin": this.requestData.choosed_qualification[index].bin,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id
				}).then((response) => {
					this.collegeLangList[index] = response.data.data;
				});
				this.isLoading = false;
			},
			languageChanged(index) {
				this.requestData.choosed_qualification[index].target_grant = false;
				this.getTargetGrant(index);
			},
			async getTargetGrant(index) {
				this.isLoading = true;
				await this.$http.post('/targetGrant', {
					"region_ab": this.requestData.region_ab,
					"qualification_code": this.requestData.choosed_qualification[index].code,
					"college_bin": this.requestData.choosed_qualification[index].bin,
					"training_type_id": this.requestData.training_type_id,
					"education_form_id": this.requestData.education_form_id,
					"education_type_id": this.requestData.education_type_id,
					"payment_type_id": this.requestData.payment_type_id,
					"lang_short": this.requestData.choosed_qualification[index].lang
				}).then((response) => {
					this.collegeTargetGrantList[index] = response.data.data.is_have;
				});
				this.isLoading = false;
			},
			form086ToBase64(file) {
				this.form086File = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.form_086_document = response;
					});
				}
				this.requestData.form_086 = null;
			},
			educationDocumentToBase64(file) {
				this.educationDocumentFile = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.education_document = response;
					});
				}
				this.requestData.education_document = null;
			},
			quotaDocumentToBase64(file) {
				this.quotaDocumentFile = file || null;
				if (this.usesMetadataApi) {
					return;
				}
				if (file) {
					this.toBase64(file).then((response) => {
						this.requestData.quota_list[0].document = response;
					});
				}
				this.requestData.quota_list[0].document = null;
			},
			async toBase64(file) {
				return new Promise((resolve) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4));
						}
						resolve(encoded);
					};
				});
			},
			async submitRequest() {
				if (!this.$refs.formStep6.validate()) {
					return;
				}
				this.syncChildToRequestData();
				this.isLoading = true;
				try {
					if (this.usesMetadataApi) {
						const formData = buildAddOrderFormData(
							this.requestData,
							this.qualificationSelected,
							{
								form086File: this.form086File,
								educationDocumentFile: this.educationDocumentFile,
								quotaDocumentFile: this.quotaDocumentFile,
							},
							{ regionList: this.regionList },
						);
						const response = await this.$http.post('/add-order', formData);
						const message = response.data.message || this.$t('Заявка успешно отправлена');
						this.$store.dispatch('alertAdd', { text: message, type: 'success' });
						this.$router.push({ path: '/abiturient/my-requests' });
						return;
					}
					const response = await this.$http.post('/request', this.requestData);
					this.$store.dispatch('alertAdd', { text: this.$t('Заявка успешно отправлена'), type: 'success' });
					this.$router.push({ path: '/abiturient/my-requests/' + response.data.data.id });
				} finally {
					this.isLoading = false;
				}
			},
		},
		watch: {
			'$store.state.language': function () {
				this.reloadLocalizedListsOnLanguageChange();
			},
			'requestData.training_type_id': function () {
				if (!this.requestData.is_undeveloped_place) {
					this.requestData.education_form_id = null;
					this.requestData.region_ab = null;
					this.clearQualificationList();
				}
			},
			'requestData.payment_type_id': function () {
				if (!this.requestData.is_undeveloped_place) {
					this.clearQualificationList();
				}
			},
			'requestData.education_type_id': function (v) {
				if (v == 1 || v == 2) {
					this.getCountry();
					this.getRegion();
				} else {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
				this.requestData.education_document_type_id = null;
				this.getEducationDocument();
				if (!this.requestData.is_undeveloped_place) {
					this.clearQualificationList();
				}
			},
			'requestData.school_country_id': function (v) {
				if (v != 398 && v != 192) {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
			},
			'requestData.school_region_ab': function () {
				this.onSchoolRegionChange();
			},
		},
	};
</script>